import type { PageLike } from "~/models/PageLike";
import type { Page } from "~/models/page";

import type { TreeItems } from "./types";

export const makePageTree = <T extends Page | PageLike>(items: T[]): TreeItems<T> => {
	// Tree without children.
	const pagesByParent = (items || []).reduce<Record<string, TreeItems<T>>>((acc, page) => {
		const parentId = page.parentPageID ?? "";
		if (!acc[parentId]) {
			acc[parentId] = [];
		}
		acc[parentId]?.push({
			id: page.id,
			collapsed: false,
			children: [],
			data: page,
		});
		return acc;
	}, {});

	// Add children.
	const rootTreeItems: TreeItems<T> = [];
	for (const treeItem of Object.values(pagesByParent).flat()) {
		treeItem.children = pagesByParent[treeItem.id] ?? [];
		if (treeItem.data.parentPageID === null) {
			rootTreeItems.push(treeItem);
		}
	}

	return rootTreeItems;
};
